import React from 'react';

import { IwiAffiliationFormProvider } from './IwiAffiliationFormContext';

export const IwiAffiliationFormBehalfOf = () => <IwiAffiliationFormProvider />;
